import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";


export class SetPersonalInfoModifiedAction extends BaseAction<void, { isModified: boolean }> {
    override async run(): Promise<void> {
        try {
            const { isModified } = this.params!;
            updateRecoilState("isPersonalInfoModifiedAtom", isModified);
        } catch (error) {
            console.error("Error in SetPersonalInfoModifiedAction:", error);
        }
    }
}

export const setPersonalInfoModifiedAction = new SetPersonalInfoModifiedAction();